import { DetailedOverview } from './DetailedOverview'

/**
 * Same dashboard as Detailed Overview (identical panels/filters), just
 * scoped to Checklists and Tasks — Work Orders never appear here, not
 * just hidden by default. Opens on the Checklists view; the Type
 * filter only offers Tasks/Checklists so there's no way to switch back
 * to Work Orders from this tab.
 */
export function ChecklistOverview() {
  return <DetailedOverview defaultItemType="checklist" allowedItemTypes={['task', 'checklist']} />
}
